import React, { useEffect } from 'react';

import { useUpdate, useListController, useGetOne, CRUD_GET_ONE, useVersion } from 'react-admin';
import { get } from 'lodash';
import useCustomNotify from 'hooks/useCustomNotify';

import ListView from './ListView';

export const usePagingStoreController = (listProps) => {
  const version = useVersion();

  const { data, loaded } = useGetOne('rowsPerPageSettings', listProps.resource, {
    version,
    action: CRUD_GET_ONE,
  });

  const [update] = useUpdate('rowsPerPageSettings', listProps.resource);

  return {
    update,
    data,
    loaded,
  };
};

const ListViewWrapped = ({ perPage, update, ...props }) => {
  const notify = useCustomNotify();
  const controllerProps = useListController({ ...props, perPage });

  // Listen for dataProvider errors (custom event approach for react-admin v3)
  useEffect(() => {
    const handleDataProviderError = (event) => {
      const { error, resource, message } = event.detail;

      // Only handle errors for the current resource
      if (resource === props.resource || resource === controllerProps.resource) {
        console.error('List API Error:', error);
        notify(message, 'error');
      }
    };

    window.addEventListener('dataProviderError', handleDataProviderError);

    return () => {
      window.removeEventListener('dataProviderError', handleDataProviderError);
    };
  }, [notify, props.resource, controllerProps.resource]);

  const setPerPage = (value) => {
    update({
      payload: {
        data: {
          perPage: value,
        },
      },
    });

    controllerProps.setPerPage(value);
  };

  return <ListView {...props} {...controllerProps} setPerPage={setPerPage} />;
};

const List = (props) => {
  const { data: perPageStore, update } = usePagingStoreController(props);
  const perPage = get(perPageStore, 'perPage', 10);

  return <ListViewWrapped perPage={perPage} update={update} {...props} />;
};

export default List;
